import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  template: `
    <div
      class="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2 w-[min(92vw,420px)]"
      aria-live="polite"
    >
      @for (t of toastService.toasts(); track t.id) {
        <div
          role="alert"
          class="flex items-center gap-2 px-4 py-3 rounded-xl border border-[var(--border)] bg-[var(--bg-surface)] shadow-lg text-sm text-[var(--text)]"
        >
          @if (t.type === 'success') {
            <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-emerald-100">
              <lucide-icon name="check" class="h-3.5 w-3.5 shrink-0 text-emerald-600"></lucide-icon>
            </span>
          } @else if (t.type === 'error') {
            <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100">
              <lucide-icon name="x" class="h-3.5 w-3.5 shrink-0 text-red-600"></lucide-icon>
            </span>
          } @else {
            <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-slate-100">
              <lucide-icon name="info" class="h-3.5 w-3.5 shrink-0 text-slate-600"></lucide-icon>
            </span>
          }
          <span class="flex-1 min-w-0">{{ t.message }}</span>
          <button
            type="button"
            (click)="toastService.dismiss(t.id)"
            class="shrink-0 p-1 rounded hover:bg-[var(--hover)] text-[var(--muted)]"
            aria-label="Fechar"
          >
            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);
}
